import { GRAPH_APRECOM_SYSTEM_ERROR_MESSAGE } from '../constants/commonConstants';

/**
 * True when Aprecomm GraphQL returned a JWT / auth error in the errors array.
 *
 * @param {*} error - Axios or fetch error (optional `response.data.errors`).
 * @return {boolean} Whether the first GraphQL error indicates JWT/auth failure.
 */
export function isAprecomJwtAuthError(error) {
	const msg = error?.response?.data?.errors?.[0]?.message;
	if (!msg || typeof msg !== 'string') return false;
	return (
		msg.includes('TokenExpiredError') ||
		msg.includes('JsonWebTokenError') ||
		msg.includes('jwt expired') ||
		msg.includes('invalid signature')
	);
}

/**
 * User-visible message after a failed Aprecomm graph request.
 * Network failures (e.g. ERR_CONNECTION_REFUSED) use the product system copy, not "Token Expired".
 *
 * @param {*} error - Axios or fetch error from an Aprecomm graph call.
 * @return {string} GraphQL auth error message, or the shared system load-failure message constant.
 */
export function getAprecomCatchUserMessage(error) {
	if (isAprecomJwtAuthError(error)) {
		return (
			error?.response?.data?.errors?.[0]?.message ||
			'Token Expired. Please re-login'
		);
	}
	return GRAPH_APRECOM_SYSTEM_ERROR_MESSAGE;
}
